module.exports = __webpack_public_path__ + "img/twitter.6ed41345.svg";